export const todayDate = () =>{
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();
    return dd + '-' + mm + '-' + yyyy;
}


export const getDefaultFuelDate = () => {
    let dt={};
    var startDate=new Date();
    startDate.setMonth(startDate.getMonth()-3);
    dt.startDate=startDate;
    dt.endDate=new Date();
    return dt;
}

export const getDefaultLubeDate = () => {
    let dt={};
    var startDate=new Date();
    startDate.setMonth(startDate.getMonth()-6);
    dt.startDate=startDate;
    dt.endDate=new Date();
    return dt;
}
export const getDefaultTotDate = () => {
    let dt={};
    var startDate=new Date();
    startDate.setMonth(startDate.getMonth()-12);
    dt.startDate=startDate;
    dt.endDate=new Date();
    return dt;
}
export const getCurrentDate = () =>{
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();
    // return dd + '-' + mm + '-' + yyyy;
    return yyyy + '-' + mm + '-' + dd;

    //console.log(dd,mm,yyyy);
}
export const getDefaultTrendsDate = () => {
    //debugger
    let dt={};
    var startDate=new Date();
    startDate.setMonth(startDate.getMonth()-12);
    dt.startDate=startDate;
    dt.endDate=new Date();
    return dt;
}
export const getCurrentDateOfBelow = (preValue) =>{
    //console.log(preValue);
    let today = new Date();
    today.setDate(today.getDate() - (preValue));
    // var dateString = date.toISOString().split('T')[0];
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();
    return yyyy + '-' + mm + '-' + dd;

    //console.log(dd,mm,yyyy);
}

export const getCurrentYearOfFiveBelow = (preValue) =>{
    //console.log(preValue);
    let today = new Date();
    today.setDate(today.getFullYear() - (preValue));
    // var dateString = date.toISOString().split('T')[0];
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();
    return yyyy + '-' + mm + '-' + dd;

    //console.log(dd,mm,yyyy);
}